import PageWrapper from "../../common/components/PageWrapper";
import BoxWithShadow from "../../common/components/BoxWithShadow";
import BasicButton from "../../common/components/BasicButton";
import useReportContainer from "./ReportContainer.hook";
import UpdateReportReasonModal from "../components/UpdateReportReasonModal";
import Loader from "../../common/components/Loader";
import ReportReasonItem from "../components/ReportReaasonItem";
import CountCard from "../../common/components/CountCard";

export default function ReportContainer() {
  const {
    models: {
      isUpdatingReason,
      selectedReason,
      loading,
      totalCount,
      activeReasons,
      inactiveReasons,
    },
    operations: { onUpdateReason, closeUpdateModal },
  } = useReportContainer();

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {isUpdatingReason && (
        <UpdateReportReasonModal
          isOpen={isUpdatingReason}
          onClose={closeUpdateModal}
          reportReason={selectedReason}
        />
      )}
      <PageWrapper isColumnFlex={false}>
        <BoxWithShadow className="w-1/5 gap-3">
          <p className="text-lg font-bold">신고사유 현황</p>
          <CountCard label="전체 사유" count={totalCount} unit="개" />
          <CountCard
            label="활성 사유"
            count={activeReasons?.length}
            unit="개"
          />
          <CountCard
            label="비활성 사유"
            count={inactiveReasons?.length}
            unit="개"
          />
          <BasicButton
            text="사유 추가"
            className="mt-auto w-full"
            onClick={() => onUpdateReason()}
          />
        </BoxWithShadow>
        <BoxWithShadow className="w-2/5 gap-3">
          <p className="text-lg font-bold">
            활성 신고사유 (총 {activeReasons.length}개)
          </p>
          <div className="flex h-full flex-col gap-3 overflow-y-auto">
            {activeReasons?.map((reason, index) => (
              <ReportReasonItem
                key={reason.id}
                number={index + 1}
                onSelect={() => onUpdateReason(reason)}
                reportReason={reason}
              />
            ))}
          </div>
        </BoxWithShadow>
        <BoxWithShadow className="w-2/5 gap-3">
          <p className="text-lg font-bold">
            비활성 신고사유 (총 {inactiveReasons?.length}개)
          </p>
          <div className="flex h-full flex-col gap-3 overflow-y-auto">
            {inactiveReasons?.map((reason, index) => (
              <ReportReasonItem
                key={reason.id}
                number={index + 1}
                onSelect={() => onUpdateReason(reason)}
                reportReason={reason}
              />
            ))}
          </div>
        </BoxWithShadow>
      </PageWrapper>
    </>
  );
}
